import { BulkImportLearnerPage } from "@/features/learner/components/learner-bulk-import/BulkImportLearnerPage";

const LearnerBulkImport = () => {
  return <BulkImportLearnerPage />;
};

export default LearnerBulkImport;
